import { createModalStore } from '@/shared/lib/modal';

export const useScreenRecordPromoModalStore = createModalStore();
